/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { MyInjector } from "@src/app/app.module";
import { Cycle } from "@src/app/model/cycle";
import { ActionColor, IFormAction } from "@src/app/shared/form/form.component";
import { CycleService } from "@src/app/modules/budget/cycle.service";
import { tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { CyclePageNavRoute } from "@src/app/routes/app-router";

export class NextCycleAction implements IFormAction {
    name = $localize`Create Next`;
    color: ActionColor = 'primary';
    show = true;
    icon = 'skip_next';
    approvalNeeded = true;
    disabled = false;
    approvalText = "Create the next annual cycle using all of the data from this cycle as the default values";
    tipText: string = $localize`Creates next cycle / financial year`;

    action(cycle: Cycle) {
        const cs = MyInjector.instance.get(CycleService);

        return cs.createNext(cycle).pipe( tap((next:Cycle) => {
            if (next) {
                const router = MyInjector.instance.get(Router);
                router.navigate([CyclePageNavRoute.getIdUrl(next.id)]);
            }
        }));
    }

    setup() {
        this.show = true;
    }
}
